// Product image zoom/unzoom (prevent cart or menu button from being clicked when zoomed in on an image)
$('.pswp__button--close').on('pswpTap', function (event) {
    event.stopPropagation()
})

$(document).ready( function() {

    fix_cover_bg_position()

    $(window).resize( function() {
        fix_cover_bg_position()
    })
})

function fix_cover_bg_position() {
    $('.wp-block-cover.is-style-100-width > .wp-block-cover__image-background').each( function() {
        var position = $(this).css('object-position')
        var yPosition = position.split(' ')[1];
        var height = parseInt($(this).height())
        var transformY = parseFloat(yPosition) / 100.0 * height;

        $(this).css('transform', 'translateY( -' + transformY + 'px )')
        $(this).css('top', yPosition)
    })
}